import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shop"
const ShopIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M10.5 12.75C11.328 12.75 12 13.422 12 14.25V17.25C12 18.078 11.328 18.75 10.5 18.75H6.75C5.922 18.75 5.25 18.078 5.25 17.25V14.25C5.25 13.422 5.922 12.75 6.75 12.75zM6.75 17.25H10.5V14.25H6.75z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M19.317 2.25C19.814 2.25 20.279 2.497 20.557 2.908L22.242 5.388C22.409 5.636 22.5 5.93 22.5 6.231V8.25C22.5 8.343 22.484 8.425 22.468 8.494 22.36 9.29 21.958 9.994 21.376 10.49V20.25C21.375 21.078 20.703 21.75 19.875 21.75H4.125C3.297 21.75 2.625 21.078 2.625 20.25V10.491C2.041 9.994 1.638 9.291 1.53 8.492 1.514 8.421 1.5 8.34 1.5 8.25V6.23C1.5 5.93 1.591 5.637 1.76 5.389L3.441 2.908 3.497 2.832C3.779 2.467 4.217 2.25 4.683 2.25zM16.875 10.111C16.291 10.806 15.418 11.25 14.438 11.25S12.584 10.806 12 10.111C11.416 10.806 10.543 11.25 9.563 11.25S7.709 10.806 7.124 10.111C6.541 10.806 5.668 11.25 4.688 11.25Q4.399 11.249 4.125 11.2V20.25H13.5V14.25C13.5 13.422 14.172 12.75 15 12.75H17.25C18.078 12.75 18.75 13.422 18.75 14.25V20.25H19.875V11.2Q19.601 11.249 19.313 11.25C18.333 11.25 17.459 10.806 16.875 10.111M15 20.25H17.25V14.25H15zM3 6.23V8.189L3.004 8.203 3.012 8.271C3.115 9.104 3.826 9.75 4.688 9.75 5.484 9.75 6.153 9.197 6.328 8.453L6.467 7.875H7.784L7.921 8.453C8.097 9.197 8.766 9.75 9.562 9.75 10.36 9.75 11.029 9.197 11.205 8.453L11.34 7.875H12.659L12.796 8.453C12.972 9.197 13.641 9.75 14.438 9.75S15.903 9.197 16.078 8.453L16.217 7.875H17.534L17.671 8.453C17.847 9.197 18.516 9.75 19.313 9.75 20.173 9.75 20.885 9.104 20.987 8.27L20.995 8.203 21 8.186V6.23L19.317 3.75H4.683z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ShopIcon
